import type { FloatingContext as FloatingContextType } from '@floating-ui/react';
import { createContext } from 'react';

export const FloatingContext = createContext<FloatingContextType | null>(null);
